/**
 * Choix de la langue d'affichage au chargement de la page.
 *
 * ⚠️ Il n'y a NI détection navigateur, NI sélecteur de langue sur les écrans
 * publics (le sélecteur vit dans `Layout`, donc seulement une fois connecté) :
 * sans ce paramètre d'URL, un prospect anglophone remplit le formulaire de
 * création de compte en français. Les liens de la vitrine portaient déjà
 * `?lang=` — il n'était simplement lu par personne.
 *
 * Priorité : `?lang=` (lien partagé) > choix mémorisé > français.
 */

export const SUPPORTED_LANGUAGES = ["fr", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** Normalise « EN », « en-GB », « en_US »… en « en ». `null` si non supportée. */
export function normalizeLanguage(raw: string | null | undefined): SupportedLanguage | null {
  const lang = raw?.trim().toLowerCase().slice(0, 2);
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(lang || "")
    ? (lang as SupportedLanguage)
    : null;
}

/**
 * Langue à appliquer, à partir de la query string et du choix mémorisé.
 * Fonction pure — les effets (localStorage, i18next) restent à l'appelant.
 */
export function pickInitialLanguage(search: string, stored: string | null): SupportedLanguage {
  const fromUrl = normalizeLanguage(new URLSearchParams(search).get("lang"));
  if (fromUrl) return fromUrl;
  return normalizeLanguage(stored) || "fr";
}
